import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../../environments/environment';

import { QueryMetaData } from '../query-metadata';
import { Task } from '../task';
import { TaskService } from '../task.service';
import { ProfileService } from '../profile.service';

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.scss'],
    standalone: false
})
export class TaskListComponent implements OnInit {

  private route = inject(ActivatedRoute);
  private taskService = inject(TaskService);
  private profileService = inject(ProfileService);
  private cdr = inject(ChangeDetectorRef);

  tasks: Task[];
  selectedTask: Task;
  query: QueryMetaData;

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
        const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
        const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.query = { start, size } as QueryMetaData;

        // Wait for profile to be loaded before fetching tasks
        if (this.profileService.isAuthenticated()) {
          this.getTasks(this.query);
        } else {
          // Listen for profile loaded event
          window.addEventListener('profile:loaded', () => {
            this.getTasks(this.query);
          }, { once: true });
        }
      }
    );
  }

  getTasks(query: QueryMetaData): void {
    this.taskService.getTasks(query)
        .subscribe(tasks => {
          this.tasks = tasks;
          this.cdr.detectChanges();
        });
  }

  onSelect(task: Task): void {
    this.selectedTask = task;
  }
}
